import type { ReactNode } from "react";
import whatsNewImage from "@/assets/whats-new.svg";

interface AuthScreenShellProps {
  children: ReactNode;
}

const AuthScreenShell = ({ children }: AuthScreenShellProps) => {
  return (
    <div className="lmn-auth-page">
      <div className="lmn-auth-main">
        <section className="lmn-auth-panel">
          <div className="lmn-auth-card">{children}</div>
        </section>
        <aside className="lmn-auth-visual" aria-hidden="true">
          <a
            className="lmn-auth-whats-new"
            href="https://www.lumana.ai/product-updates"
            target="_blank"
            rel="noreferrer"
            aria-label="What's new at Lumana"
          >
            <img src={whatsNewImage} alt="" />
          </a>
        </aside>
      </div>
    </div>
  );
};

export default AuthScreenShell;
